import React, { Fragment, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useStateSelector } from '../../../store/selectors';
import { LoadUserSummaryFromStorage } from '../../../slices/user-summary/load-user-summary-from-storage';
import { LoadLimitsFromStorage } from '../../../slices/current-user/load-limits-from-storage.thunk';
import { LoadLimits } from '../../../slices/current-user/load-limits.thunk';
import { RoleMenuSwitcher } from './RoleMenuSwitcher';
import { AnnouncementsMenuSection } from './AnnouncementsMenuSection';
import { canAccessAnnouncements } from './member-access';

export const LeftMenu = () => {
    const dispatch = useDispatch() as any;
    const summary = useStateSelector((state) => state.userSummary.summary);
    const limits = useStateSelector((state) => state.currentUser.limits);
    useEffect(() => {
        dispatch(LoadUserSummaryFromStorage());
        dispatch(LoadLimitsFromStorage()).then((response: any) => {
            if (!response.payload) {
                return dispatch(LoadLimits());
            }
            return response;
        });
    }, [dispatch]);

    if (!summary || !limits) {
        return null;
    }

    return (
        <Fragment>
            {canAccessAnnouncements(summary) && <AnnouncementsMenuSection />}
            <RoleMenuSwitcher user={summary} limits={limits} />
        </Fragment>
    );
};
